import { ValidationRuleset } from 'vuelidate';
import { SignUpOptions } from '@/store/models';
import { required, email, sameAs, minLength } from 'vuelidate/lib/validators';

export type TSignUp = { signUp: SignUpOptions; validationGroup: string[] };

const phoneRegex = /^(\+84|0)[0-9]{8,9}$/;

export const phoneRegexCheck = (val: string) => {
  return phoneRegex.test(val);
};

const existsEmail = () => {
  return true;
};

export const signUpValidator: ValidationRuleset<TSignUp> = {
  signUp: {
    username: {
      required
    },
    display_name: {
      required
    },
    email: {
      required,
      email,
      existsEmail
    },
    password: {
      required,
      minLength: minLength(6)
    },
    passwordConfirmation: {
      required,
      samAsPassword: sameAs('password')
    },
    phone: {
      required,
      phoneRegexCheck
    }
  }
};
